import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=6fa5e30c&scope=true&lang=sass"

const __exports__ = script;

export default __exports__